import React from 'react';
import SelectEntityFactory from '../Common/SelectEntityFactory';
import AssetActions from '../../actions/AssetActionCreator';
import { SearchTypes } from '../../constants/CentricConstants';

export default SelectEntityFactory(AssetActions.search, {searchType: SearchTypes.ASSETS});
